import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class Radiobuttons extends Component {

  /* Render */

  render() {
    const { onChange, selected, values, disabled } = this.props;
    const radiobuttons = values.map((button) => {
      const checked = selected === button.value;
      const radiobuttonClassNames = classNames('radiobuttons__item', { 'is-active': checked, 'is-disabled': disabled });

      return (
        <div key={button.id} className={radiobuttonClassNames}>
          <label className="radiobuttons__container" htmlFor={button.value}>
            <div className="align align--fluid align--gutter-sm">
              <div className="align__cell align__cell--shrink">
                <input
                  checked={checked}
                  className="radiobuttons__input"
                  disabled={disabled}
                  id={button.value}
                  onChange={(e) => { onChange(e.target.value, button); }}
                  type="radio"
                  value={button.value}
                />
                <span className="radiobuttons__icon" />
              </div>
              <div className="align__cell">
                {button.label}
              </div>
            </div>
          </label>
        </div>
      );
    });

    return (
      <div className="radiobuttons">
        {radiobuttons}
      </div>
    );
  }
}

Radiobuttons.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  selected: PropTypes.any,
  values: PropTypes.array,
};



// WEBPACK FOOTER //
// ./js/components/radiobuttons/index.jsx